<div class="page-heading modal-content-header">
    <h1 class="layer-title">{{ header }}</h1>
</div>

<div class="modal-content-body">
    <div  [formGroup]="formGroup">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <label for="startDate" class="required">{{formGroup.value.endDate ? 'Date de début': 'Date prévisionnelle'}}</label>
                <ed-datepicker
                    id="startDate"
                    formControlName="startDate"
                    ></ed-datepicker>
            </div>
            <div class="col-sm-12 col-md-6">
                <label for="amountExclTax"  class="required">Montant HT</label>
                <ed-numberfield
                    id="amountExclTax"
                    formControlName="amountExclTax"
                    unit="€ HT"
                    >
                </ed-numberfield>
            </div>

        </div>
        <div class="row">
            <div class="col-sm-12  col-md-6 ">
                <label for="endDate">Date de fin (Si Abonnement)</label>
                <ed-datepicker
                    id="endDate"
                    formControlName="endDate"
                    ></ed-datepicker>
            </div>
            <div class="col-sm-6">
                @if(formGroup.value.endDate){
                    <label for="subscriptionBillingTiming">Date de facturation (si abonnement)</label>
                    <ed-select
                        id="subscriptionBillingTiming"
                        formControlName="subscriptionBillingTiming"
                        [options]="subscriptionBillingTimingOptions"
                        ></ed-select>
                }
            </div>
        </div>        
        <div class="row">
            <div class="col-sm-12">
                <label for="comment">Motif</label>
                <ed-textfield
                    id="comment"
                    formControlName="comment"
                    >
                </ed-textfield>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
            <label for="comment">Type de récurrence</label>
            <ed-select
                [options]="recurrenceTypeOptions"
                [ngModel]="recurrenceType"
                (ngModelChange)="recurrenceType=$event"
                >
            </ed-select>
            </div>
        <div class="col-sm-6">
            <label for="comment">Date de fin de la récurrence :</label>
            <ed-datepicker
                [ngModel]="endRecurrence"
                (ngModelChange)="updateEndRecurrence($event)"
                >
            </ed-datepicker>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12"><i>Cette action générera {{countGeneratedBillings()}} factures</i></div>
    </div>   
</div>

<div class="layer-actions">
    <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
    <ed-button (click)="valid()" [disabled]="isDirty()">Valider</ed-button>
</div>
@if(projectSoldAmountMismatch()){
        <label>
            <i style="color: red">La somme des factures prévisionnelles ({{getSumFormatted()}} €HT) ne correspond pas au montant vendu de la mission ( {{project?.soldAmount }} €HT) :  {{getSum()- (project?.soldAmount||0)}} €HT
            </i>
        </label>
    }